// removed by extract-text-webpack-plugin
module.exports = {"link-cta":"Link__link-cta","linkCta":"Link__link-cta"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Link/Link.css
// module id = 1179
// module chunks = 8